import { getFunctions, httpsCallable } from "firebase/functions";
import {collection, doc, getDoc, getDocs} from "firebase/firestore";
import {firestore} from "../../../../services/firebase";

const functions = getFunctions();



export const createNewProduct = (data) => {
   const createNewProductHandler = httpsCallable(functions, "createProductHandler");
    return createNewProductHandler({ ...data });  
}


export const getProductById = (id) => {
    return getDoc(doc(firestore, 'products', id))
}


export const getOffers = (productId) => {
    return getDocs(collection(firestore, 'products', productId, 'offers'));
}

export const getOfferById = (productId, offerId) => {
    return getDoc(doc(firestore, 'products', productId, 'offers', offerId))
}

export const createNewOffer = (data) => {
    const createNewOfferHandler = httpsCallable(functions, "createNewOfferHandler");
     return createNewOfferHandler({ ...data });  
 }

export const createCheckout = (prouductData) =>  {
     const buyProductHandler = httpsCallable(functions, "buyProductHandler");

    return buyProductHandler({ ...prouductData });
}

// URL de pagamento da compra única: `url` = link de pagamento (/paymentlinks);
// `checkouts` = formato antigo (/orders).
export const getCheckoutPaymentUrl = (res) => {
    const body = res?.data?.body;
    return body?.url || body?.checkouts?.[0]?.payment_url;
}

export const activateExistingOffer = ({productId, offerId}) => {
    const activateOfferHandler = httpsCallable(functions, "activateOfferHandler");
    if (!!offerId) {
        return activateOfferHandler({ productId, offerId })
    }
    
    return activateOfferHandler({ productId })

}


export const getPaymentFractions = ({price, paymentFractions}) => {
    const paymentFractionsHandler = httpsCallable(functions, "paymentFractionsHandler");

    return paymentFractionsHandler({ price, paymentFractions});
}

export const editCourseOnStripe = (data) => {
    const fn = httpsCallable(functions, "editCourseOnStripe");
    return fn({ ...data });
};

/**
 * Edita um plano no Stripe (wrapper).
 * Uso: await editPlanOnStripe(payload) -> res.data (ex.: { success: true, updated: {...} })
 */
export const editPlanOnStripe = (data) => {
    const fn = httpsCallable(functions, "editPlanOnStripe");
    return fn({ ...data });
};

/**
 * Adiciona um plano no Stripe (wrapper), caso você esteja usando essa callable.
 */
export const addPlanOnStripe = (data) => {
    const fn = httpsCallable(functions, "addPlanOnStripe");
    return fn({ ...data });
};

/**
 * Lista os alunos que têm o produto com data de fim de acesso DIFERENTE da data
 * fixa informada. Somente leitura — nada é gravado aqui.
 *
 * @param {string} productId
 * @param {string} [fixedExpirationDate] Data 'YYYY-MM-DD' a simular. Permite ver
 *   o impacto de uma data que o admin acabou de escolher e ainda NÃO salvou;
 *   sem ela, o backend usa a data já salva no produto.
 */
export const previewProductExpirationMigration = async (productId, fixedExpirationDate) => {
    const fn = httpsCallable(functions, "previewProductExpirationMigration");
    const response = await fn({ productId, fixedExpirationDate });
    return response.data;
};

/**
 * Aplica a data fixa do produto aos alunos selecionados. A data gravada é sempre
 * a que está SALVA no produto; `fixedExpirationDate` vai junto apenas para o
 * backend recusar a operação caso o produto tenha mudado desde a consulta.
 *
 * @param {string} productId
 * @param {string[]} userIds IDs dos alunos escolhidos pelo admin
 * @param {string} [fixedExpirationDate] Data exibida na lista consultada
 */
export const applyProductExpirationMigration = async (productId, userIds, fixedExpirationDate) => {
    const fn = httpsCallable(functions, "applyProductExpirationMigration");
    const response = await fn({ productId, userIds, fixedExpirationDate });
    return response.data;
};

export const getCurrentDomainFromFirestore = async () => {
    const snap = await getDoc(doc(firestore, "customization", "infos"));

    if (!snap.exists()) {
        throw new Error("Documento customization/infos não encontrado");
    }

    const data = snap.data();
    const rawWebUrl = data?.webUrl;

    if (!rawWebUrl) {
        throw new Error("Propriedade webUrl não configurada");
    }

    const domain = rawWebUrl
        .replace(/^https?:\/\//i, "") // remove http:// ou https://
        .replace(/\/$/, "");          // remove barra final, se tiver

    if (!domain) {
        throw new Error("Domínio inválido em webUrl");
    }

    return domain; // ex.: "meudominio.com"
};